// @flow
import React from 'react';
import ReactTooltip from 'react-tooltip';
import './DisableContent.css';
import type {Element} from 'react';

export type Props = {
  disabled: boolean,
  children?: number | string | Element<*> | Array<any>,
};

const DisableContent = ({
  disabled,
  children,
}: Props) => (
  <div className="DisableContent">
    {children}
    {disabled &&
      <div
        className="DisableContent-overlay"
        data-tip
        data-for="disable-content">
        <ReactTooltip
          id="disable-content"
          class="DisableContent-tooltip">
          <span>Du har osparade ändringar</span>
        </ReactTooltip>
      </div>
    }
  </div>
);

export default DisableContent;



// WEBPACK FOOTER //
// ./src/components/DisableContent/DisableContent.js